import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
// Grafana plugin renders an entity card + dashboards tab driven by the
// 'grafana/dashboard-selector' / 'grafana/tag-selector' / 'grafana/alert-label-selector'
// annotations. Backed by a Backstage proxy → monitor.wecodeforgood.com (config in
// app-config.yaml). Auth uses GRAFANA_TOKEN (Grafana service-account token) from
// the backstage-secrets K8s Secret.
import grafanaPlugin from '@backstage-community/plugin-grafana/alpha';
import { navModule } from './modules/nav';
import { signInPageModule } from './modules/signInPage';
import { pagesModule, argoWorkflowsNewPlugin, openCostNewPlugin, entityLogsModule } from './modules/pages';
import { guestGuardModule } from './modules/guestGuard';

export default createApp({
  features: [
    catalogPlugin,
    navModule,
    signInPageModule,
    guestGuardModule,
    pagesModule,
    argoWorkflowsNewPlugin,
    openCostNewPlugin,
    entityLogsModule,
    grafanaPlugin,
  ],
});
